__turbopack_context__.v({
  "answerContent": "FAQ-module-scss-module__VoI6za__answerContent",
  "answerText": "FAQ-module-scss-module__VoI6za__answerText",
  "answerWrapper": "FAQ-module-scss-module__VoI6za__answerWrapper",
  "divider": "FAQ-module-scss-module__VoI6za__divider",
  "expanded": "FAQ-module-scss-module__VoI6za__expanded",
  "faqContainer": "FAQ-module-scss-module__VoI6za__faqContainer",
  "faqItem": "FAQ-module-scss-module__VoI6za__faqItem",
  "iconWrapper": "FAQ-module-scss-module__VoI6za__iconWrapper",
  "itemsContainer": "FAQ-module-scss-module__VoI6za__itemsContainer",
  "questionButton": "FAQ-module-scss-module__VoI6za__questionButton",
  "questionLetter": "FAQ-module-scss-module__VoI6za__questionLetter",
  "questionText": "FAQ-module-scss-module__VoI6za__questionText",
  "rotated": "FAQ-module-scss-module__VoI6za__rotated",
  "subtitle": "FAQ-module-scss-module__VoI6za__subtitle",
  "title": "FAQ-module-scss-module__VoI6za__title",
  "titleContainer": "FAQ-module-scss-module__VoI6za__titleContainer",
});
